export default "__VITE_ASSET__CKB5ACcx__"